import React from "react";
import { Helmet } from "react-helmet-async";
import '../terms/terms.css';

const Privacy = () => {
  return (
    <div className="sr-terms">
      <Helmet>
        <title>Privacy Policy - SastiRide</title>
        <meta name="description" content="How SastiRide collects, uses, and protects your personal data. Read our privacy policy for ride-sharing services in Pakistan." />
        <link rel="canonical" href="https://sastiride.com/privacy" />
      </Helmet>
      <div className="sr-terms__top">
        <h1 className="sr-terms__title">Privacy Policy</h1>
        <p className="sr-terms__subtitle">Last updated: {new Date().toLocaleDateString()}</p>
      </div>

      <div className="sr-terms__body">
        <div className="sr-terms__content">
          <div className="sr-terms__section">
            <h2>1. Information We Collect</h2>
            <p>We collect information you provide during registration (name, email, phone number, gender), ride details you post, and usage data to improve our services.</p>
          </div>

          <div className="sr-terms__section">
            <h2>2. How We Use Your Information</h2>
            <p>Your information is used to: provide and maintain the SastiRide service, facilitate ride connections between users, send account-related communications (verification emails, password resets), and improve the platform experience.</p>
          </div>

          <div className="sr-terms__section">
            <h2>3. Information Sharing</h2>
            <p>We do not sell your personal information. Limited information (name, phone number) is shared with other users only when you post or book a ride, to facilitate ride coordination. We may share information with law enforcement if required by law.</p>
          </div>

          <div className="sr-terms__section">
            <h2>4. Data Security</h2>
            <p>We implement security measures including password hashing, session encryption, and MongoDB query sanitization to protect your data. However, no method of transmission over the internet is 100% secure.</p>
          </div>

          <div className="sr-terms__section">
            <h2>5. Cookies and Sessions</h2>
            <p>SastiRide uses session cookies to maintain your login state. These are essential for the platform to function and are not used for advertising or tracking purposes.</p>
          </div>

          <div className="sr-terms__section">
            <h2>6. Data Retention</h2>
            <p>Your account data is retained as long as your account is active. Deleted accounts are soft-deleted (marked as inactive) but personal data may be retained for legal compliance. Contact us to request permanent data removal.</p>
          </div>

          <div className="sr-terms__section">
            <h2>7. Your Rights</h2>
            <p>You have the right to: access your personal data, update your profile information, request account deletion, and opt out of non-essential communications.</p>
          </div>

          <div className="sr-terms__section">
            <h2>8. Changes to This Policy</h2>
            <p>We may update this privacy policy from time to time. We will notify registered users of significant changes via email.</p>
          </div>

          <div className="sr-terms__section">
            <h2>9. Contact</h2>
            <p>For privacy-related questions, contact us at <a href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}>{process.env.REACT_APP_CONTACT_EMAIL}</a>.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
